/* eslint-disable */
import { useSelector } from "react-redux";
import AllRoute from "./routes/AllRoute";
import Navbar from "./components/UserComponents/UserNavbar";
import { Box, Text } from "@chakra-ui/react";
import { LanguageProvider } from "./context/LanguageContext";

import { SessionTimeout } from "./components/SessionTimeout";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <SessionTimeout>
          <AllRoute />
        </SessionTimeout>
      </div>
    </LanguageProvider>
  );
}

export default App;
